import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { removeFromObjects, updateSimpleArray } from '../../../global/common/sorting';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import AppForm from '../../../global/components/forms/appForms/AppForm';
import Checker from '../../../global/components/forms/elements/Checker';
import MenuSelect from '../../../global/components/menus/MenuSelect';
import JsonViewer from '../../../global/components/viewers/JsonViewer';
import StepWizard from '../../../global/components/wizard/StepWizard';
import { appFormTypes } from '../../../global/enums/appFormTypes';
import { appUserLevels } from '../../../global/enums/globalEnums';
import { createRefPath_event } from '../../../global/firestoreData/appData/appRefPaths';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { _allowGolfEventUpdates } from '../cnr/reducers/GolfEventReducer';
import { golfEnums } from '../enums/golfEnums';
import { golfHelpers } from '../helpers/golfHelpers';
import LineupBuilder from './LineupBuilder';

const stepTypes = {
  select: 'select',
  position: 'position',
}

const _getPlayerRecords = true
const _groupCount = 2

const _additionalProp = ['courseRoundHandicap']

const GolfLineupSelect = (props) => {

  const { callbackSave, round, golfers_lineup, teamKey, roundWizardProps } = props
  const { roundType: roundType_round } = round ?? {}
  const { team: selectedTeamKey, roundType: selectedRoundType } = roundWizardProps ?? {}
  const _selectedTeamKey = selectedTeamKey ? selectedTeamKey : teamKey
  const _selectedRoundType = selectedRoundType ? selectedRoundType : roundType_round
  const _teamKey = 'team' + _selectedTeamKey

  // golfParentContext 
  const parentContext = useContext(ParentContext)
  const { fns: fnss } = parentContext ?? {}
  const { database_fns } = fnss ?? {}

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers, fns } = golfParent_contexts ?? {}
  const { golfTournament_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { golfTournament_handlers } = handlers ?? {}
  const { appUser_fns } = fns ?? {}

  const allowMods = appUser_fns.validateAccess_item(appUserLevels.superAdmin)

  // golfTournamentContext  
  const { golfTournament, lineupInfo, details, updating, confirmation, lineups: lineups_tournament, rounds } = golfTournament_state ?? {}
  const { _itemKey } = golfTournament ?? {}
  const _round = rounds[_selectedRoundType]
  const { numberOfMatches, golfersPerTeam } = _round ?? {}
  const fixedCount = numberOfMatches * golfersPerTeam
  let _numberOfMatches = numberOfMatches
  if (_selectedRoundType === golfEnums.roundTypes.singles) { _numberOfMatches = _numberOfMatches / 2 }

  const { lineups, golfers: golfers_tournament } = details ?? {}
  const { selectedKeys: selectedLineupItems, roundLineup } = lineupInfo ? lineupInfo : {}

  let _teamRoundLineup = lineups && lineups[_teamKey] && lineups[_teamKey][_selectedRoundType] ? lineups[_teamKey][_selectedRoundType] : null

  if (selectedTeamKey && lineups_tournament?.['team' + selectedTeamKey]?.[round]) {
    const _selectedRoundLineup = lineups_tournament['team' + selectedTeamKey][round]
    _teamRoundLineup = _selectedRoundLineup
  }

  const golfers_team = golfers_tournament ? _.pickBy(golfers_tournament, { teamNumber: parseInt(_selectedTeamKey) }) : {}

  let steps = [stepTypes.select, stepTypes.position]

  const _selectedLineupItems = selectedLineupItems ? selectedLineupItems : []

  const [step, setStep] = useState({ index: 0, name: steps[0] })
  const [showPreview, setShowPreview] = useState()
  const [showSaveAs, setShowSaveAs] = useState()
  const [golfer_partners, setGolfer_partners] = useState()

  const stepCount = steps.length

  useEffect(
    () => {
      if (_getPlayerRecords && golfers_team) {
        const cb = (golfer_partners) => {
          const totals = {}

          _.forEach(golfer_partners, (tournament) => {
            _.forEach(tournament, (partners, golferKey) => {
              const golferInfo = golfers_team[golferKey]

              if (golferInfo) {
                // Ensure golfer entry exists
                if (!totals[golferKey]) {
                  totals[golferKey] = {
                    firstName: golferInfo?.firstName || '',
                    lastName: golferInfo?.lastName || '',
                    partners: {},
                  }
                }

                _.forEach(partners, (partnerData, partnerKey) => {
                  const partnerInfo = totals[golferKey].partners[partnerKey]

                  // Ensure partner entry exists
                  if (!partnerInfo) {
                    totals[golferKey].partners[partnerKey] = {
                      firstName: partnerData?.firstName || '',
                      lastName: partnerData?.lastName || '',
                      rounds: {},
                      records: { wins: 0, losses: 0, ties: 0 },
                    }
                  }

                  const partnerTotals = totals[golferKey].partners[partnerKey]
                  const partnerRecord = partnerData?.record || {}
                  const partnerRounds = partnerData?.rounds || {}

                  // ✅ Add to overall totals
                  partnerTotals.records.wins += partnerRecord.wins || 0
                  partnerTotals.records.losses += partnerRecord.losses || 0
                  partnerTotals.records.ties += partnerRecord.ties || 0

                  // ✅ Add to per-round totals
                  _.forEach(partnerRounds, (round, roundKey) => {
                    if (!partnerTotals.rounds[roundKey]) {
                      partnerTotals.rounds[roundKey] = {
                        record: { wins: 0, losses: 0, ties: 0 }
                      }
                    }

                    const { record } = round ?? {}

                    partnerTotals.rounds[roundKey].record.wins += record.wins || 0
                    partnerTotals.rounds[roundKey].record.losses += record.losses || 0
                    partnerTotals.rounds[roundKey].record.ties += record.ties || 0
                  })
                })
              }


            })
          })
          setGolfer_partners(totals)
        }
        const ref = createRefPath_event(pathViews, ['golfer_partners'])
        database_fns.get_data({ refPath: ref, callback: cb, opts: { ignoreId: true } })
      }

      // } 
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, []
  )

  // set the seleted array
  useEffect(() => {
    const { golfCourse } = round ?? {}
    if (_teamRoundLineup) {
      _teamRoundLineup.forEach(trl => {
        const { courseHandicaps } = trl
        if (courseHandicaps && golfCourse && courseHandicaps[golfCourse]) {
          trl[_additionalProp] = courseHandicaps[golfCourse]
        }
        trl.teebox = 'black'
      })
    }
    golfTournament_handlers.handleLineup_init({ teamRoundLineup: _teamRoundLineup, golfers_lineup, golfers_team, fixedCount })
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_teamRoundLineup]);

  /**
   * This will save the lineup
   */
  const handleSaveLinup = () => {
    golfTournament_handlers.handleStartUpdate()
    const _lineup = previewData(true)
    const _callback = callbackSave ? callbackSave : props.handleCancel
    if (_lineup) { golfTournament_handlers.handleLineup_update(_teamKey, _selectedRoundType, _lineup, _callback) }
  }

  const handleShowPreview = () => setShowPreview(!showPreview)
  const handleShowSaveAs = () => setShowSaveAs(!showSaveAs)
  const handleCancel = () => props.handleCancel()

  const handleOpenDb = () => {
    openExternal.firebaseDbDirect(pathViews, ['golfTournaments', _itemKey, 'details', 'details'])
  }

  const handleSelect = (e, item) => {
    const { key: itemKey } = item ?? {}
    const _selected_arr = updateSimpleArray(golfers_team, _selectedLineupItems, itemKey)
    golfTournament_handlers.handleLineup_select(_selected_arr)
  }

  const handleSaveAs = (formData) => {
    const { name } = formData
    const _lineup = previewData(true)
    const _ref = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'lineups_' + _selectedTeamKey, name])
    const data = {
      lineup: _lineup
    }
    database_fns.set_doc(_ref, data)
  }

  const handleSelectAll = (e, item, checked) => {
    let _selectedKeys = [..._selectedLineupItems]
    if (!checked) {
      Object.keys(golfers_team).forEach(key => {
        _selectedKeys.push(key)
      })
    } else {
      _selectedKeys = []
    }
    golfTournament_handlers.handleLineup_select(_selectedKeys)
  }

  const previewData = (forSave) => {
    // only change the selected team lineup for the round 
    if (forSave) { removeFromObjects(roundLineup, ['courseTeeboxes', 'checked', 'name', 'lastName', 'firstName', 'qualifier', 'teamNumber', 'courseHandicap', 'courseHandicaps', 'courseRoundHandicap']) }
    const _lineup = _.orderBy(roundLineup, ['groupNumber', 'position'])
    return _lineup
  }

  const handleUpdateArray = (round_lineup) => {
    golfTournament_handlers.handleAmmend_roundLineup(round_lineup)
  }

  const assignRandomPositions = (items) => {
    const positions = _.range(items.length);       // [0..n-1]
    const shuffled = _.shuffle(positions);         // e.g. [2,0,3,1]

    const updated = items.map((item, idx) => ({
      ...item,
      position: shuffled[idx],
    }));

    // sort by the new random position → ensures order changes
    const sorted = _.sortBy(updated, "position");
    golfHelpers.ammendLineupGroups(sorted, _groupCount)
    handleUpdateArray(sorted)
  };


  const handleRandom = () => assignRandomPositions(roundLineup)

  const validateComponent = () => {
    switch (step.name) {
      case stepTypes.select:
        return _selectedLineupItems.length === fixedCount
      case stepTypes.position:
        return roundLineup ? true : false
      default:
        break;
    }
  }

  const allowBack = step.index > 0
  const allowForward = (step.index < (stepCount - 1) && validateComponent())


  const buttons_select = () => {
    const btns = []
    btns.push({ oc: handleOpenDb, caption: 'Open DB', icon: 'database', color: 'orange', fl: true })
    return <UiSaveButtons others={btns} />
  }

  const stepCaption = () => {
    const name = _.startCase(step.name)
    switch (step.name) {
      case stepTypes.select:
        return name + ' (' + _selectedLineupItems.length + ') of (' + fixedCount + ')'
      default:
        return name
    }
  }

  const selectWrapper = (golfers_team_sorted) => <Wrapper
    header={header()}
    content={<MenuSelect
      menuList={golfers_team_sorted}
      handleSelect={handleSelect}
      selectedItems={_selectedLineupItems}
      listSize={'small'}
    />}
    footer={allowMods && buttons_select()}
    wrapperType={wrapperTypes.padded}
  />

  const header = () => <Segment basic style={{ padding: 0 }}><Checker cnp='checker-lineup' label={'Select All'} handle_click={handleSelectAll} item={{ key: 'selectAll' }} /></Segment>

  const footer_position = () => {
    let btns = [
      { caption: 'Randomize', oc: handleRandom, icon: 'random', fl: true },
      { disabled: !allowMods, caption: 'Update', oc: handleSaveLinup, icon: 'save', color: _allowGolfEventUpdates.any && _allowGolfEventUpdates.detailsUpdate ? 'green' : 'olive', additionalBtns: [{ oc: handleShowPreview, icon: 'eye', color: showPreview ? 'blue' : 'grey' }] },
      { disabled: !allowMods, caption: 'Save as', oc: handleShowSaveAs, icon: 'arrow right', fl: true }
    ]
    return <UiSaveButtons others={btns} />
  }

  const step_content = () => {

    switch (step.name) {

      case stepTypes.select:
        const golfers_team_sorted = _.orderBy(golfers_team, ['lastName', 'firstName'])
        return selectWrapper(golfers_team_sorted)

      case stepTypes.position:
        return <Wrapper
          content={showPreview ? contentPreview() : <LineupBuilder
            golfer_partners={golfer_partners}
            groupCount={_groupCount}
            handleUpdateArray={handleUpdateArray}
            items={roundLineup}
            propsToShow={_additionalProp}
            selectedRoundType={_selectedRoundType}
            allowSorting={true}
          />}
          footer={footer_position()}
          wrapperType={wrapperTypes.paddedContent}
        />

      default:
        break;
    }
  }

  const contentPreview = () => <JsonViewer json={previewData()} name={'Lineup'} />

  const stepWizard = () => <StepWizard
    allowBack={allowBack}
    allowForward={allowForward}
    confirmation={confirmation}
    content={step_content()}
    handleCancel={handleCancel}
    setStep={setStep}
    step={step}
    stepCaption={stepCaption()}
    steps={steps}
    topperCaption={'Create Lineup'}
    topperCaption2={_.startCase(_selectedRoundType) + ' (Team ' + _selectedTeamKey + ')'}
    useTopper={true}
    updating={updating}
  ></StepWizard>

  const appForm = () => <AppForm
    appFormType={appFormTypes.simpleInput}
    handleCancel={handleShowSaveAs}
    handleSave={handleSaveAs}
    handleSaveCaption={'Save'}
    topperCaption={'Save As'}
    useFullPageWrapper={true}
    css={{ container: 'app-dark-mode' }}
  />

  if (showSaveAs) {
    return appForm()
  } else {
    return step ? stepWizard() : <div></div>
  }

}

export default GolfLineupSelect